export const accountId = 'f00000000037329';
export const brightEdgeApiUrl = 'https://ixfd-api.bc0a.com/api/ixf/1.0.0/get_capsule';
